import { ReactNode } from 'react';
import { Box } from 'src/components/Box/Box';
import { Icon } from 'src/components/Icon';
import { IconName } from 'src/components/Icon/Icon.types';
import { Sizes } from 'src/design-system/style-types';

interface Props {
  children: ReactNode;
  icon?: IconName;
  iconSize?: Sizes;
}

export const SelectLabelWithIcon = ({ children, icon, iconSize = 'xl' }: Props) => (
  <Box a="center" wrap="nowrap">
    {icon && <Icon name={icon} size={iconSize} marginRight="md" />}
    {children}
  </Box>
);
